import { useEffect, useState } from 'react';

import { usePlatform } from '../platform/platform-context';

export function useOnline(): boolean {
  const { lifecycle } = usePlatform();
  const initial = lifecycle.isOnline();
  const [online, setOnline] = useState(initial.ok ? initial.value : true);

  useEffect(() => {
    const subscription = lifecycle.subscribeOnline(setOnline);
    return subscription.ok ? subscription.value : undefined;
  }, [lifecycle]);

  return online;
}
